import { checkCompatibility } from '@actions'

const TextArea = ({
    onFocus,
    ...props
}) => {
    
    const onKeyDown = e => {
        // need to stop propagation so it doesnt mess up with other components
        e.stopPropagation()
    }
    
    // Check for Grammarly errors on focus, since the extension
    // doesn't modify the dom until the field is focused
    const handleFocus = e => {
        
        setTimeout(checkCompatibility, 1000)
        
        if (onFocus)
            onFocus(e)
        
    }
    
    return (
        
        <textarea onFocus={handleFocus} onKeyDown={onKeyDown} {...props} />
        
    )
    
}

export default TextArea
